import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../UserContext";

const ModuleGuard = ({ moduleKey, children }) => {
  const { user } = useUser();

  // Si no hay usuario, redirigir al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario es administrador y está sin rol, permitir acceso
  if (user.es_administrador && user.sinRol) {
    return children;
  }

  // Verificar si el módulo está disponible (comparación case-insensitive)
  const modulo = user.modulos?.find(
    (m) => m.key?.toLowerCase() === moduleKey.toLowerCase()
  );
  if (!modulo || modulo.estado !== "disponible") {
    // Redirigir al dashboard si no tiene acceso
    return <Navigate to="/modules/Dashboard" replace />;
  }

  // Si tiene acceso al módulo, renderizar el componente
  return children;
};

export default ModuleGuard;
